import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.requestQueue = [];
    this.currentRequest = null;
    const Uppy = require("@uppy/core");
    const PortugueseBrazil = require("@uppy/locales/lib/pt_BR");
    const ActiveStorageUpload = require("uppy-activestorage-upload");
    const Dashboard = require("@uppy/dashboard");
    const Webcam = require("@uppy/webcam");
    const uppy = Uppy({
      locale: {
        strings: {
          exceedsSize: 'Arquivo muito grande. Não envie arquivos maiores do que ',
          youCanOnlyUploadX: {
            '0': 'Você pode enviar no máximo %{smart_count} arquivo por vez',
            '1': 'Você pode enviar no máximo %{smart_count} arquivos por vez'
          },
        }
      },
      onBeforeFileAdded: (currentFile, files) => {
        if (typeof currentFile.data.name == "undefined") {
          currentFile.data.name = currentFile.name
        }
      },
      restrictions: {
        maxFileSize: 10485760, // 10MB
        maxNumberOfFiles: 20,
        allowedFileTypes: [
          ".jpg",
          ".jpeg",
          ".png",
          ".gif",
          ".pdf",
          ".doc",
          ".docx",
          ".xls",
          ".xlsx",
          ".tiff"
        ]
      }
    })
      .use(Dashboard, {
        trigger: ".upload-this",
        closeModalOnClickOutside: true,
        proudlyDisplayPoweredByUppy: false,
        locale: PortugueseBrazil,
        note: "Cada arquivo com no máximo 10 MB. Você pode enviar no máximo 20 arquivos por vez.",
        closeAfterFinish: true,
        locale: {
          strings: {
            addMore: 'Adicione mais',
            addMoreFiles: 'Adicione mais arquivos',
            saveChanges: 'Salvar alterações',
            importFrom: 'Capturar imagem da %{name}',
            back: 'Voltar',
            addingMoreFiles: 'Adicionando mais arquivos',
            done: 'Voltar',
            edit: 'Editar',
            cancel: 'Cancelar',
            myDevice: 'Carregar do meu computador',
            browse: 'carregue do seu computador',
            dropPasteImport: "Arraste seus arquivos aqui, ou escolha uma das opções abaixo:",
            dropPaste: 'Arraste seus arquivos aqui ou %{browse}',
            xFilesSelected: {
               0: '%{smart_count} arquivo selecionado',
               1: '%{smart_count} arquivos selecionados'
            },
            uploadXFiles: {
              0: 'Enviar %{smart_count} arquivo',
              1: 'Enviar %{smart_count} arquivos'
            },
            uploadXNewFiles: {
              0: 'Enviar +%{smart_count} arquivo',
              1: 'Enviar +%{smart_count} arquivos'
            },
            uploading: 'Enviando',
            complete: 'Completo',
            uploadComplete: 'Envio completo'
          }
        },

        metaFields: [
          { id: "name", name: "Nome", placeholder: "nome do arquivo" },
          {
            id: "notes",
            name: "Descrição",
            placeholder: "descrição do arquivo"
          }
        ]
      })
      .use(Webcam, {
        target: Dashboard,
        modes: ["picture"],
        locale: {
          strings: {
            // Shown before a picture is taken when the `countdown` option is set.
            smile: "Smile!",
            // Used as the label for the button that takes a picture.
            // This is not visibly rendered but is picked up by screen readers.
            takePicture: "Tirar foto",
            // Title on the “allow access” screen
            allowAccessTitle: "Por favor, permita acesso a sua câmera",
            // Description on the “allow access” screen
            allowAccessDescription:
              "Para poder tirar foto ou gravar um video, precisa permitir acesso a sua câmera."
          }
        }
      })
      .use(ActiveStorageUpload, {
        directUploadUrl: this.data.get("directUploadsUrl")
      })
      .on("upload-success", (file, response) => {
        this.requestQueue.push({
          upload: {
            name: file.meta.name,
            notes: file.meta.notes,
            file: response.signed_id
          }
        })
      });

      setInterval(() => this.handleQueueRequests(), 100)
  }

  handleQueueRequests(){
    if (this.requestQueue.length > 0 && this.currentRequest == null){
      this.currentRequest = this.requestQueue.shift()
      this.requestUpload(this.currentRequest)
    }
  }

  requestUpload(data){
    $.ajax({
      type: "POST",
      url: this.data.get("uploadPath"),
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
      },
      data: data,
      complete: (response) => {
        this.currentRequest = null
        this.handleQueueRequests()
      }
    });
  }
}
